import React, {Component,PropTypes} from 'react';

// Import libraries
import i18n from 'lib/i18n'
import c from 'state/constants'

// Import styles and object styles for modals
import styles from '../taskList.scss'

// Setup translation group to agenda2
const _ = i18n('agenda2')

export default class NotificationContent extends Component
{
    /**
	 * Set the required property types for the component
	 */
	static propTypes = {
        items: React.PropTypes.array,
        deleteTaskAction: React.PropTypes.func.isRequired,
        notificationType: React.PropTypes.string,
        notificationItemId: React.PropTypes.string,
        toggleModal: React.PropTypes.func.isRequired,
        resetTaskColorsAction: React.PropTypes.func.isRequired,
        deleteColorAction: React.PropTypes.func.isRequired,
    }

    /**
     * Handle submit based on notification type
     */
    handleSubmit() {
        const { notificationType, notificationItemId, resetTaskColorsAction, items, deleteTaskAction, deleteColorAction} = this.props

        if(notificationType == 'deleteColor')
        {
            deleteColorAction(notificationItemId)
        }

        if(notificationType == 'resetColors')
        {
            resetTaskColorsAction()
        }

        if(notificationType == 'deleteTasks')
        {
            deleteTaskAction(items)
        }
    }

    render() {
        const {notificationType, toggleModal, items } = this.props
        let filteredItems = items.filter(item => !item.isDeleted).filter(item => !item.hidden)
        let checkedItems = items.filter(item => !item.isDeleted).filter(i => i.checked === true).map(i => i)
        checkedItems = checkedItems.filter(item => !item.hidden).map(i => i.id)

        return(
            <div className={styles.todoModalContent + " " + styles.colXs}>
                { (notificationType == 'resetColors') && <span className={styles.title}>{_("confirmReset")}</span> }
                { (notificationType == 'deleteTasks') && <span className={styles.title}>{_("confirmDeleteTasks")}</span> }
                { (notificationType == 'deleteColor') && <span className={styles.title}>{_('confirmDeleteColor')}</span>}

                <div className={styles.confirmationMessage}>
                    { (notificationType == 'resetColors') && <span>{_("confirmResetMessage")}</span> }
                    { (notificationType == 'deleteTasks') && <span>{_('confirmDeleteTasksSubj')} {checkedItems.length} {_("confirmDeleteTasksMessage")}</span> }
                    { (notificationType == 'deleteColor') && <span>{_('confirmDeleteColorMessage')}</span>}
                </div>

				<div className={styles.todoModalButtons}>
					<span
  					onClick={() => {
                            toggleModal(c.TASK_MODULE_MODAL_NAME_NOTIFICATION)
                        }}
						className={styles.cancel}
					>
						{_("cancel")}
					</span>
					<input
						onClick={(event) => this.handleSubmit(event)}
						type="button"
						className={styles.greyButton}
						value={_('confirm')}
					/>
				</div>
			</div>
        )
    }

}



// WEBPACK FOOTER //
// ./components/taskList/components/notificationContent.jsx